/** Public reference only; authentication and tenant boundaries continue to use the existing IDs. */
export function softwareLicenseNumber(value?: number | null): string {
  return Number.isInteger(value) && value! > 0 ? `CMAS-${String(value).padStart(6, '0')}` : 'In assegnazione';
}
